// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22BEO","label":"styles_label__2CxQm"};